<template>
    <Loading v-model:active="isActive" :is-full-page="isFullPage" color="#3490dc" opacity=0.8 />
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    emits: ['hide', 'update:active'],
    data() {
        return {
            // Don't mutate the prop
            isActive: this.active
        }
    },
    components: {
        Loading,
    },
    props: {
        active: Boolean,
        isFullPage: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        active(value) {
            this.isActive = value
        },
    },
}
</script>